import { Component } from '@angular/core';
import { PageviewsettingsService } from '../services/pageviewsettings.service';
import { TenantService } from '../services/tenant.service';
import * as Globals from '../../globals';

declare let analytics: any;

@Component({
  selector: 'app-giveaways',
  templateUrl: './giveaways.component.html',
  styleUrls: ['./giveaways.component.css']
})

export class GiveawaysComponent {
	affiliateId: any;
	loadeddata: any;
	tenantId: any;
	tenant: TenantService;
	tenantName: string = window.location.href.split('/')[3];

	constructor(private settingsService: PageviewsettingsService, private tenantService: TenantService) {
		this.tenant = tenantService;

		this.settingsService.getCollegetenantcode(this.tenantName).subscribe(data => {
			this.tenantId = parseInt(data.result.id)
			this.affiliateId = data.result.affiliateId
			this.loadPageSettings();
		});
	}

	loadPageSettings() {
		this.settingsService.getPageViewSettings(this.affiliateId, this.tenantId).subscribe(data => {
			this.loadeddata = data.result;
			const color = this.loadeddata?.PrimaryColor;

			if (color) {
				document.documentElement.style.setProperty('--primary', color);
			} else {
				document.documentElement.style.setProperty('--primary', 'white');
			}
		});
	}

	trackevent(event:any){
		analytics.track(event)
	}
}
